import { atom } from 'recoil'
import { IEquipmentModel } from './equipmentModels.types.ts'

interface IEquipmentModelsState {
  items: IEquipmentModel[]
}

const equipmentModelsAtom = atom<IEquipmentModelsState>({
  key: 'equipmentModels',
  default: { items: [] },
})
export default equipmentModelsAtom
